
import {defineComponent} from 'vue';
import {useBrowserlocationComposition} from "@/composables/BrowserlocationComposition";
import {useFilterComposition} from "@/composables/FilterComposition";
import {useStoreComposition} from "@/composables/StoreComposition";
import {useGeolocationComposition} from "@/composables/GeolocationComposition";
import {configuration} from "@/composables/ConfigurationComposition";
import {useTranslationComposition} from "@/composables/TranslationComposition";

export default defineComponent({
  components: {},
  setup() {
    const {
      distanceRef,
      typeRef,
      regionRef
    } = useFilterComposition;

    return {
      geolocationComposition: useGeolocationComposition,
      browserlocationComposition: useBrowserlocationComposition,
      storeComposition: useStoreComposition,
      translationComposition: useTranslationComposition,
      filterComposition: useFilterComposition,
      configuration,
      distanceRef,
      typeRef,
      regionRef
    }
  },
  data() {
    return {
      isOpened: false
    };
  },
  computed: {
    isOpenedCSSClass() {
      //@ts-ignore
      return this.isOpened ? 'opened' : ''
    },
    resultTypes() {
      return configuration.resultTypes ?? [];
    }
  },
  methods: {
    change() {
      this.storeComposition.loadStores();
    },
    open() {
      this.isOpened = true;
    },
    close() {
      this.isOpened = false;
    },
    toggle() {
      this.isOpened = !this.isOpened;
    },
    reset() {
      this.filterComposition.reset();

      this.$emit('reset');
    }
  },
  mounted() {
    this.reset();
  }
});
